import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil, catchError, of } from 'rxjs';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Footer } from '../../../shared/footer/footer';
import { Header } from '../../../shared/header/header';

// Auth imports
import { AuthService } from '../../../core/services/auth.service';
import { TokenStorageService } from '../../../core/services/token-storage.service';
import { LoginRequest } from '../../../core/models/auth.models';
import { LoaderService } from '../../../services/loader.service';
import { Dialog } from 'primeng/dialog';
import { EmailVerificnOtpDialog } from '../sign-up/email-verificn-otp-dialog/email-verificn-otp-dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { SendOtpRequest } from '../forms/forms.model';
import { UserRegistrationService } from '../../../services/user-registration.service';
import { MonoovaService } from '../../../services/monoova.service';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    MessageModule,
    ProgressSpinnerModule,
    ToastModule,
    Header,
    Footer,
    Dialog,
  ],
  providers: [MessageService, DialogService],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit, OnDestroy {
  private loaderService = inject(LoaderService);
  private destroy$ = new Subject<void>();
  private authService = inject(AuthService);
  private tokenStorage = inject(TokenStorageService);
  private messageService = inject(MessageService);
  private dialogService = inject(DialogService);
  private userService = inject(UserRegistrationService);
  private monovaService = inject(MonoovaService);
  messagePopupVisible: boolean = false;
  private isShowingToast = false;

  loginData: LoginRequest = {
    email: '',
    password: '',
    grantType: 'PASSWORD',
  };

  isLoading = false;
  errorMessage = '';
  successMessage = '';
  showTestCredentials = true;
  formSubmitted = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.authService.isLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLoading) => {
        this.isLoading = isLoading;
      });

    // this.authService.error$
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((error) => {
    //     if (error) {
    //       this.errorMessage = error;
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Login Failed',
    //         detail: error,
    //         life: 5000,
    //       });
    //     }
    //   });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // onSubmit(): void {
  //   this.formSubmitted = true;

  //   if (!this.isValidForm()) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Validation Error',
  //       detail: 'Please fill in all required fields correctly',
  //       life: 3000,
  //     });
  //     return;
  //   }

  //   this.clearMessages();
  //   this.loaderService.show();

  //   // Call the auth service to login
  //   this.authService
  //     .login(this.loginData)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       // next: (response) => {
  //       //   this.successMessage = response.message || 'Login successful!';
  //       //   this.messageService.add({
  //       //     severity: 'success',
  //       //     summary: 'Success',
  //       //     detail: this.successMessage,
  //       //     life: 3000,
  //       //   });
  //       //   const user = response.user;
  //       //   this.monovaService
  //       //     .checkAndStoreSubscriptionStatus({
  //       //       roleId: user.roleId,
  //       //       userId: user.userId,
  //       //       businessId: user.businessId,
  //       //     })
  //       //     .subscribe({
  //       //       next: (isActive) => {
  //       //         console.log('isActiveSubscription flag:', isActive);
  //       //       },
  //       //       error: (error) => {
  //       //         console.error('Error checking subscription status:', error);
  //       //       },
  //       //     });
  //       //   // Add a delay before navigation to show the toast
  //       //   setTimeout(() => {
  //       //     this.router.navigate(['/dashboard']);
  //       //     this.loaderService.hide();
  //       //   }, 500); // 1.5 second delay to show the toast
  //       // },
  //       next: (response) => {
  //         this.successMessage = response.message || 'Login successful!';

  //         // Navigate immediately without waiting
  //         this.router.navigate(['/dashboard']).then(() => {
  //           this.loaderService.hide();

  //           // Show success message after navigation
  //           this.messageService.add({
  //             severity: 'success',
  //             summary: 'Success',
  //             detail: this.successMessage,
  //             life: 3000,
  //           });
  //         });

  //         // Fire and forget subscription check
  //         const user = response.user;
  //         this.monovaService
  //           .checkAndStoreSubscriptionStatus({
  //             roleId: user.roleId,
  //             userId: user.userId,
  //             businessId: user.businessId,
  //           })
  //           .subscribe({
  //             next: (isActive) =>
  //               console.log('isActiveSubscription flag:', isActive),
  //             error: (error) =>
  //               console.error('Error checking subscription status:', error),
  //           });
  //       },
  //       error: (error) => {
  //         console.error('Login error:', error);

  //         // Prevent duplicate toasts
  //         if (this.isShowingToast) {
  //           this.loaderService.hide();
  //           return;
  //         }

  //         this.isShowingToast = true;

  //         const errorMsg = 'Login failed. Please try again.';
  //         this.errorMessage = errorMsg;

  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Login Failed',
  //           detail: errorMsg,
  //           life: 5000,
  //         });

  //         this.loaderService.hide();

  //         // Reset flag after toast duration
  //         setTimeout(() => {
  //           this.isShowingToast = false;
  //         }, 5000);
  //       },
  //       complete: () => {
  //         // Don't hide loader here for success case as it's handled in setTimeout
  //       },
  //     });
  // }
  // In login.ts component

  // onSubmit(): void {
  //   this.formSubmitted = true;

  //   if (!this.isValidForm()) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Validation Error',
  //       detail: 'Please fill in all required fields correctly',
  //       life: 3000,
  //     });
  //     return;
  //   }

  //   this.clearMessages();
  //   this.loaderService.show();

  //   // Call the auth service to login
  //   this.authService
  //     .login(this.loginData)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       // next: (response) => {
  //       //   this.successMessage = response.message || 'Login successful!';
  //       //   this.messageService.add({
  //       //     severity: 'success',
  //       //     summary: 'Success',
  //       //     detail: this.successMessage,
  //       //     life: 3000,
  //       //   });
  //       //   const user = response.user;
  //       //   this.monovaService
  //       //     .checkAndStoreSubscriptionStatus({
  //       //       roleId: user.roleId,
  //       //       userId: user.userId,
  //       //       businessId: user.businessId,
  //       //     })
  //       //     .subscribe({
  //       //       next: (isActive) => {
  //       //         console.log('isActiveSubscription flag:', isActive);
  //       //       },
  //       //       error: (error) => {
  //       //         console.error('Error checking subscription status:', error);
  //       //       },
  //       //     });
  //       //   // Add a delay before navigation to show the toast
  //       //   setTimeout(() => {
  //       //     this.router.navigate(['/dashboard']);
  //       //     this.loaderService.hide();
  //       //   }, 500); // 1.5 second delay to show the toast
  //       // },
  //       next: (response) => {
  //         this.successMessage = response.message || 'Login successful!';

  //         // Navigate immediately without waiting
  //         this.router.navigate(['/dashboard']).then(() => {
  //           this.loaderService.hide();

  //           // Show success message after navigation
  //           this.messageService.add({
  //             severity: 'success',
  //             summary: 'Success',
  //             detail: this.successMessage,
  //             life: 3000,
  //           });
  //         });

  //         // Fire and forget subscription check
  //         const user = response.user;
  //         this.monovaService
  //           .checkAndStoreSubscriptionStatus({
  //             roleId: user.roleId,
  //             userId: user.userId,
  //             businessId: user.businessId,
  //           })
  //           .subscribe({
  //             next: (isActive) =>
  //               console.log('isActiveSubscription flag:', isActive),
  //             error: (error) =>
  //               console.error('Error checking subscription status:', error),
  //           });
  //       },
  //       error: (error) => {
  //         console.error('Login error:', error);

  //         // Prevent duplicate toasts
  //         if (this.isShowingToast) {
  //           this.loaderService.hide();
  //           return;
  //         }

  //         this.isShowingToast = true;

  //         const errorMsg = 'Login failed. Please try again.';
  //         this.errorMessage = errorMsg;

  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Login Failed',
  //           detail: errorMsg,
  //           life: 5000,
  //         });

  //         this.loaderService.hide();

  //         // Reset flag after toast duration
  //         setTimeout(() => {
  //           this.isShowingToast = false;
  //         }, 5000);
  //       },
  //       complete: () => {
  //         // Don't hide loader here for success case as it's handled in setTimeout
  //       },
  //     });
  // }
  // In login.ts component

  onSubmit(): void {
    this.formSubmitted = true;

    if (!this.isValidForm()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'validation error',
        detail: 'please fill in all required fields correctly',
        life: 3000,
      });
      return;
    }

    this.clearMessages();
    localStorage.removeItem('business_signup_pending_completion');
    localStorage.removeItem('referralCode');
    this.loaderService.show();

    this.authService
      .login(this.loginData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          const user = response.user;

          // Check subscription status before navigating
          this.monovaService
            .checkAndStoreSubscriptionStatus({
              roleId: user.roleId,
              userId: user.userId,
              businessId: user.businessId,
            })
            .pipe(
              catchError((error) => {
                // If subscription check fails, allow navigation anyway
                // User can be prompted for subscription later
                console.warn('Subscription check failed, proceeding with login:', error);
                this.tokenStorage.setSubscriptionStatus(true);
                return of(true);
              }),
              takeUntil(this.destroy$)
            )
            .subscribe({
              next: (isActive) => {
                console.log('isActiveSubscription flag:', isActive);

                this.loaderService.hide();

                const isOrgAdmin =
                  user.roleId === 4 ||
                  (Array.isArray(user.roles) &&
                    user.roles.some(
                      (r: any) =>
                        (typeof r === 'string' ? r : r.RoleName) === 'OrgAdmin',
                    ));
                const isTeamMember = !isOrgAdmin;

                if (isActive || isTeamMember) {
                  if (isTeamMember) {
                    this.tokenStorage.setSubscriptionStatus(true);
                    localStorage.setItem('isActiveSubscription', 'true');
                  }

                  // User has active subscription or is a team member - proceed to dashboard
                  this.successMessage = (response.message || 'login successful!').toLowerCase();
                  this.messageService.add({
                    severity: 'success',
                    summary: 'success',
                    detail: this.successMessage,
                    life: 3000,
                  });

                


                   setTimeout(() => {
                    this.loaderService.show();
                      if (this.isSuperAdmin) {
                    this.router.navigate(['/insights']);
                  } else {
                    this.router.navigate(['/dashboard']);
                  }
                  }, 500);

                } else {


                  this.successMessage = (response.message || 'login successful!').toLowerCase();
                  this.messageService.add({
                    severity: 'success',
                    summary: 'success',
                    detail: this.successMessage,
                    life: 3000,
                  });
                 
                      setTimeout(() => {
                         this.loaderService.show();
                    this.router.navigate(['/dashboard']);
                  }, 500);
                  
                }
              },
              error: (error) => {
                console.error('Error after subscription check:', error);
                this.loaderService.hide();
              },
            });
        },
        error: (error) => {
          console.error('Login error:', error);

          if (this.isShowingToast) {
            this.loaderService.hide();
            return;
          }

          this.isShowingToast = true;
          const errorMsg = 'login failed. please try again.';
          this.errorMessage = errorMsg;

          this.messageService.add({
            severity: 'error',
            summary: 'login failed',
            detail: errorMsg,
            life: 5000,
          });

          this.loaderService.hide();

          setTimeout(() => {
            this.isShowingToast = false;
          }, 5000);
        },
      });
  }
  get isSuperAdmin(): boolean {
    const state = this.authService.getCurrentAuthState();
    return (state.user?.roleId === 6) || (state.user?.roles?.includes('SuperAdmin') ?? false);
  }
  private isValidForm(): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const passwordMinLength = 6;

    return !!(
      this.loginData.email &&
      emailPattern.test(this.loginData.email) &&
      this.loginData.password &&
      this.loginData.password.length >= passwordMinLength
    );
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  private clearMessages(): void {
    this.errorMessage = '';
    this.successMessage = '';
  }

  // Social login methods (placeholder implementations)
  loginWithApple(): void {
    console.log('Login with Apple');
    // TODO: Implement Apple login
  }

  loginWithGoogle(): void {
    console.log('Login with Google');
    // TODO: Implement Google login
  }

  loginWithFacebook(): void {
    console.log('Login with Facebook');
    // TODO: Implement Facebook login
  }

  loginWithEmail(): void {
    // This method seems redundant with onSubmit, but keeping for compatibility
    this.onSubmit();
  }

  navigateToSignUp(): void {
    localStorage.clear();
    localStorage.clear();
    this.router.navigate(['/sign-up']);
  }

  navigateToForgotPassword(): void {
    this.messagePopupVisible = true;
    // TODO: Implement forgot password functionality
    console.log('Navigate to forgot password');
  }

  // Header event handlers
  onLoginClicked(): void {
    this.router.navigate(['/sign-in']);
  }

  onSignupClicked(): void {
    this.router.navigate(['/forms/form1']);
  }
  closePopup() {
    this.messagePopupVisible = false;
  }
  async Continue() {
    if (!this.loginData.email || !this.isValidEmail(this.loginData.email)) {
      this.messageService.add({
        severity: 'error',
        summary: 'invalid email',
        detail: 'please enter a valid email address',
      });
      return;
    }

    this.messagePopupVisible = false;
    this.loaderService.show();

    const request: SendOtpRequest = {
      UserType: 'Business',
      Email: this.loginData.email,
    };

    try {
      const response = await this.userService
        .sendEmailOtpChangePassword(request)
        .toPromise();

      if (response && response.success) {
        this.messageService.add({
          severity: 'success',
          summary: 'code sent',
          detail: `verification code sent to ${this.loginData.email}`,
          life: 3000,
        });

        this.dialogService.open(EmailVerificnOtpDialog, {
          data: {
            email: this.loginData.email,
            isFromSettings: true,
          },
          width: '400px',
          modal: true,
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'error',
          detail: response?.message || 'failed to send OTP',
        });
      }
    } catch (error: any) {
      this.messageService.add({
        severity: 'error',
        summary: 'error',
        detail: error?.error?.message || 'something went wrong',
      });
    } finally {
      this.loaderService.hide();
    }
  }
  // Add this property to your component class
  showPassword: boolean = false;

  // Add this method to your component class
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
